import React, { Suspense } from 'react';
import { CircularProgress, IconButton } from "@mui/material";
import menus from "./menus";
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import JumboVerticalNavbar from "@jumbo/components/JumboVerticalNavbar/JumboVerticalNavbar";
import { DrawerHeader } from "@jumbo/components/JumboLayout/style";
import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import { useJumboLayoutSidebar, useJumboSidebarTheme } from "@jumbo/hooks";
import { SIDEBAR_STYLES, SIDEBAR_VIEWS } from "@jumbo/utils/constants/layout";
import Logo from "../../../../shared/Logo";
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import Zoom from "@mui/material/Zoom";
import Div from "@jumbo/shared/Div";
import { red } from "@mui/material/colors";
import SidebarSkeleton from "./SidebarSkeleton";
import { getAPIDataReturn } from "app/utils/apiFunction";
import { ACCESS, ACCESS_SECTIONS } from "app/utils/constants/access";


const Sidebar = () => {
    const [reportMenus, setReportMenus] = React.useState(null);
    var combinedMenus = [];

    React.useEffect(() => {
        getAPIDataReturn("/Reports/GetBIReportList").then((data) => {
            //group data by Category
            var groupedData = data.reduce((r, a) => {
                r[a.category] = [...r[a.category] || [], a];
                return r;
            }, {});
            setReportMenus(groupedData);


        });
    }, []);
    combinedMenus = [...menus];
    var indexMenu = combinedMenus.findIndex(x => x.label === "Reports");
    if (indexMenu > -1) {
        if (reportMenus) {
            combinedMenus[indexMenu].children = Object.keys(reportMenus).map((key) => {

                return {
                    label: key,
                    type: "collapsible",
                    icon: <DashboardOutlinedIcon sx={{ fontSize: 20 }} />,
                    access: { key: ACCESS_SECTIONS.REPORTS, value: ACCESS.MASTER },
                    children: reportMenus[key].map((rm) => {
                        return {
                            label: rm.description,
                            type: "nav-item",
                            uri: "/reports/POWERBI?reportId=" + rm.reportId,
                            
                        }
                    })
                }
            })
        } else {
            combinedMenus.splice(indexMenu, 1);
        }
    }
    console.log(combinedMenus)
    return (
        <React.Fragment>
            <SidebarHeader />
            <JumboScrollbar
                autoHide
                autoHideDuration={200}
                autoHideTimeout={500}
            >
                <Suspense
                    fallback={
                        <Div
                            sx={{
                                display: 'flex',
                                minWidth: 0,
                                alignItems: 'center',
                                alignContent: 'center',
                                px: 3
                            }}
                        >
                            <SidebarSkeleton />
                        </Div>
                    }
                >
                    <JumboVerticalNavbar translate items={combinedMenus} />
                </Suspense>
            </JumboScrollbar>
        </React.Fragment>
    );
};

const SidebarHeader = () => {
    const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();
    const { sidebarTheme } = useJumboSidebarTheme();

    const isMiniAndClosed = React.useMemo(() => {
        return sidebarOptions?.view === SIDEBAR_VIEWS.MINI && !sidebarOptions?.open;
    }, [sidebarOptions.view, sidebarOptions.open]);


    return (
        <React.Fragment>
            {
                sidebarOptions?.style !== SIDEBAR_STYLES.CLIPPED_UNDER_HEADER &&
                <DrawerHeader>
                    {/*AOC Production Portal*/}
                    <Logo mini={isMiniAndClosed} mode={sidebarTheme.type} logoSize={105}/>
                    {
                        <Zoom in={sidebarOptions?.open}>
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="open drawer"
                                sx={{ ml: 0, mr: -1.5 }}
                                onClick={() => setSidebarOptions({ open: false })}
                            >
                                <MenuOpenIcon />
                            </IconButton>
                        </Zoom>
                    }
                </DrawerHeader>
            }
        </React.Fragment>
    )
};

export default Sidebar;
